import { rem } from 'design-system';
export const getYLabels = (maxY, minY) => {
    if (maxY === 0) {
        return {
            maxHeightNegative: rem(150),
            maxHeightPositive: 0,
            yLabels: [0, minY / 4, (2 * minY) / 4, (3 * minY) / 4, minY],
        };
    }
    if (minY === 0) {
        return {
            maxHeightNegative: 0,
            maxHeightPositive: rem(150),
            yLabels: [maxY, (3 * maxY) / 4, (2 * maxY) / 4, maxY / 4, 0],
        };
    }
    const ratio = Math.abs(maxY) / Math.abs(minY);
    if (ratio > 1.42) {
        return {
            maxHeightNegative: rem(150 / 5),
            maxHeightPositive: rem((4 * 150) / 5),
            yLabels: [maxY, (2 * maxY) / 3, maxY / 3, 0, minY],
        };
    }
    if (ratio < 0.7) {
        return {
            maxHeightPositive: rem(150 / 5),
            maxHeightNegative: rem((4 * 150) / 5),
            yLabels: [maxY, 0, minY / 3, (2 * minY) / 3, minY],
        };
    }
    return {
        maxHeightNegative: rem(150 / 2),
        maxHeightPositive: rem(150 / 2),
        yLabels: [maxY, maxY / 2, 0, minY / 2, minY],
    };
};
export const getMaxMin = (data) => {
    const numbersArr = [];
    data.forEach((eachData) => {
        numbersArr.push(eachData.firstBarY);
        numbersArr.push(eachData.secondBarY);
        if (eachData.thirdBarY)
            numbersArr.push(eachData.thirdBarY);
    });
    return {
        maxY: Math.max(...numbersArr),
        minY: Math.min(...numbersArr, 0),
    };
};
export const getBarHeight = (number, maxPositive, minNegative, maxHeightPositive, maxHeightNegative) => {
    if (typeof number === 'number') {
        if (number < 0) {
            return -(number / minNegative) * maxHeightNegative;
        }
        return (number / maxPositive) * maxHeightPositive;
    }
    return undefined;
};
